import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone } from "lucide-react";
import { useLang } from "@/i18n";
import { openCookieSettings } from "@/components/CookieConsent";

const LEGAL_ROUTES = { 0: "/cookies/policy", 1: "/privacy", 2: "/legal/notice" };

export const Footer = () => {
  const { t, lang } = useLang();

  return (
    <footer data-testid="site-footer" className="bg-[#4361ee] text-white">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.3fr_1.2fr_0.8fr_1fr_0.9fr]">
          <div>
            <Link to="/" data-testid="footer-logo" className="inline-block">
              <img src="/logo-mosca-white.webp" alt="Analytics 4 People" className="h-10 w-auto" />
            </Link>
            <p className="mt-6 text-[13px] font-jakarta text-white/60 leading-relaxed max-w-[240px]">{t.footer.support}</p>
            <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-3 max-w-[280px]">
              <img data-testid="footer-partner-bcnactiva" src="/logo-bcnactiva-color.png" alt="Barcelona Activa — Ajuntament de Barcelona" className="h-8 w-auto" />
              <img data-testid="footer-partner-impacthub" src="/logo-impacthub-white.webp" alt="Impact Hub Barcelona" className="h-6 w-auto" />
            </div>
          </div>
          <div>
            <div className="font-cabinet text-sm font-bold mb-4">{t.footer.company}</div>
            <p className="text-[13px] font-jakarta text-white/55 leading-loose">{t.footer.caps}</p>
          </div>
          <div>
            <div className="font-jbmono text-[11px] uppercase tracking-[0.2em] mb-5 text-white/50">{t.footer.worlds}</div>
            <div className="flex flex-col gap-3">
              <Link data-testid="footer-link-aws" to="/aws" className="text-white/75 hover:text-white text-sm transition-colors">Infraestructura Cloud</Link>
              <Link data-testid="footer-link-martech" to="/martech" className="text-white/75 hover:text-white text-sm transition-colors">Growth Analytics</Link>
              <Link data-testid="footer-link-people" to="/people-hr" className="text-white/75 hover:text-white text-sm transition-colors">People Analytics</Link>
              <Link data-testid="footer-link-blog" to="/blog" className="text-white/75 hover:text-white text-sm transition-colors">Blog</Link>
            </div>
          </div>
          <div>
            <div className="font-jbmono text-[11px] uppercase tracking-[0.2em] mb-5 text-white/50">{t.footer.contact}</div>
            <div className="flex flex-col gap-3 text-sm text-white/75">
              <a data-testid="footer-email" href="mailto:a4p@analytics4people.com" className="flex items-center gap-2 hover:text-white transition-colors">
                <Mail size={14} /> a4p@analytics4people.com
              </a>
              <a data-testid="footer-phone" href="tel:+34687447999" className="flex items-center gap-2 hover:text-white transition-colors">
                <Phone size={14} /> 687 447 999
              </a>
              <a data-testid="footer-linkedin" href="https://www.linkedin.com/company/analytics4people" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white transition-colors">
                <Linkedin size={14} /> LinkedIn
              </a>
            </div>
          </div>
          <div>
            <div className="font-jbmono text-[11px] uppercase tracking-[0.2em] mb-5 text-white/50">{t.footer.legal}</div>
            <div className="flex flex-col gap-3">
              {t.footer.legalLinks.map((label, i) => (
                <Link key={i} data-testid={`footer-legal-${i}`} to={LEGAL_ROUTES[i]} className="text-white/75 hover:text-white text-sm transition-colors">
                  {label}
                </Link>
              ))}
              <button type="button" onClick={openCookieSettings} className="w-fit text-left text-white/75 hover:text-white text-sm transition-colors">
                {lang === "en" ? "Cookie settings" : "Configurar cookies"}
              </button>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/25 flex flex-col sm:flex-row justify-between gap-2 text-[11px] text-white/70 font-jbmono">
          <span>© {new Date().getFullYear()} {t.footer.company}. {t.footer.rights}</span>
          <span className="flex items-center gap-2">
            <img src="/aws-logo.svg" alt="AWS" className="h-3.5 w-auto" style={{ filter: "brightness(0) invert(1)" }} />
            Powered by AWS
          </span>
        </div>
      </div>
    </footer>
  );
};
